import { container } from 'tsyringe';
import { QuestionsService, Step, Steps } from '@iq-solutions/nida-shared';
import React, { useEffect, useState, createContext } from 'react';

export type AnswerValues = {
  drugs: Array<string>;
  answer: Array<string>;
};
export type SessionData = {
  currentStep?: Step | undefined;
  nextStep?: Step | undefined;
  previousStep?: Step | undefined;
  steps?: Readonly<Steps>;
  started: boolean;
  userType?: 'patient' | 'clinician';
  answers: Record<number, AnswerValues>;
  skippedSteps: Array<number>;
  completedSteps: Array<number>;
  total: number;
};

export const StepsContext = createContext<SessionData>({
  answers: {},
  started: false,
  skippedSteps: [],
  completedSteps: [],
  total: 0,
});

const StepsComponent: React.FunctionComponent = ({ children }) => {
  const [steps, setSteps] = useState<SessionData>({
    answers: {},
    started: false,
    skippedSteps: [],
    completedSteps: [],
    total: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (loading) {
      const getQuestionsData = container.resolve(QuestionsService);
      getQuestionsData
        .fetchQuestions(`${process.env.REACT_APP_QUESTIONS_API_BASE}/873`)
        .then((steps_returned) => {
          const newValue = {
            ...steps,
            answers: {
              ...steps.answers,
            },
            steps: steps_returned,
          };
          setSteps(newValue);
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    }
  });

  return <StepsContext.Provider value={steps}>{children}</StepsContext.Provider>;
};

export default StepsComponent;
